
var id = "Group";
var markup = "<symbol viewBox=\"0 0 24 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"Group\">\n    <title>Group</title>\n    <defs>\n        <path d=\"M13,5.08 C16.06,5.52 18.48,7.94 18.92,11 L21.95,11 C21.48,6.28 17.72,2.52 13,2.05 L13,5.08 Z M18.92,13 C18.48,16.06 16.06,18.48 13,18.92 L13,21.95 C17.72,21.48 21.48,17.72 21.95,13 L18.92,13 L18.92,13 Z M11,18.92 C7.61,18.43 5,15.52 5,12 C5,8.48 7.61,5.57 11,5.08 L11,2.05 C5.95,2.55 2,6.81 2,12 C2,17.19 5.95,21.45 11,21.95 L11,18.92 Z\" id=\"Group_path-1\" />\n    </defs>\n    <g id=\"Group_营销活动-小程序活动管理\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Group_活动分析\" transform=\"translate(-312.000000, -281.000000)\">\n            <g id=\"Group_区块-活动概要\" transform=\"translate(280.000000, 136.000000)\">\n                <g id=\"Group_区块-查询\" transform=\"translate(32.000000, 145.000000)\">\n                    <g id=\"Group_Group\" transform=\"translate(0.000000, 0.500000)\">\n                        <rect id=\"Group_Rectangle\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" />\n                        <g>\n                            <mask id=\"Group_mask-2\" fill=\"white\">\n                                <use xlink:href=\"#Group_path-1\" />\n                            </mask>\n                            <use id=\"Group_icon/action/donut_large_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#Group_path-1\" />\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
